// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__qRWDD","container":"Home_container__C99QM","bodyTrangChu":"Home_bodyTrangChu__AfkWF"};